import FaqAccordion from "@/components/UI/FaqAccordion";
import cart from "@/public/svg/cart.svg";
import location from "@/public/svg/route.svg";
import plantHand from "@/public/svg/plant_hand.svg";
import search from "@/public/svg/search.svg";
import home from "@/public/svg/house.svg";
import aboutUs from "@/public/svg/about-us.svg";
import transparency from "@/public/svg/transparency.svg";
import time from "@/public/svg/time-clock.svg";
import cog from "@/public/svg/cog.svg";
import briefcase from "@/public/svg/briefcase-2.svg";
import alignButtom from "@/public/svg/align-buttom.svg";
import dollarGreen from "@/public/svg/dollar-green.svg";

export default function MunicipalitiesFaqAccordions() {
    return (
        <div className="m-6">
            <h1 className="text-3xl text-center font-bold text-textColor mb-8 mt-16">Häufig gestellte Fragen</h1>
            <FaqAccordion
                icon={search}
                title="Allgemeines zum Yobsti-Konzept"
                faqs={[
                    {
                        question: "Was ist Yobsti und wie funktioniert das Konzept?",
                        answer: `
                            <p>Yobsti ist ein innovativer, personalloser Nahversorgungsmarkt für kleinere Gemeinden. Der Zugang erfolgt über eine persönliche Chipkarte – damit öffnet sich die Tür zum Laden.</p>
                            <p>Kund:innen stellen ihre gewünschten Produkte wie gewohnt in den Einkaufskorb und gehen anschließend zur Kasse. Dort scannen sie ihre Waren selbstständig ein. Wie das funktioniert, ist direkt an der Kasse verständlich erklärt.</p>
                            <p>Nach dem Bezahlen kann der Laden jederzeit wieder verlassen werden – die Tür öffnet sich nicht automatisch.</p>
                            <p>Zum Start bieten wir kleine Info-Events an, bei denen wir die Bedienung anschaulich erklären und Fragen beantworten.</p>
                        `
                    },
                    {
                        question: "Wie können wir Yobsti in unsere Gemeinde bringen?",
                        answer: `
                            <p>Ganz unkompliziert: Füllen Sie einfach unser Interessenformular aus. Wir melden uns zeitnah bei Ihnen, um in einem Erstgespräch die Gegebenheiten und Ziele Ihrer Gemeinde kennenzulernen.</p>
                            <p>Im nächsten Schritt erstellen wir eine strukturierte und für Sie kostenlose Machbarkeitsstudie.</p>
                            <ul class="list-disc list-inside mt-2 space-y-1">
                                <li>Prüfung der Standortlage, Sichtbarkeit und Erreichbarkeit</li>
                                <li>technische und baurechtliche Voraussetzungen</li>
                                <li>Wirtschaftlichkeitsanalyse inkl. Mindestumsatz</li>
                                <li>Bewertung der regionalen Versorgungssituation</li>
                                <li>Potenzialabschätzung durch eine kurze Bürgerbefragung</li>
                            </ul>
                            <p class="mt-2">So erhalten Sie eine fundierte Entscheidungsgrundlage – ohne Risiko und mit klarer Perspektive.</p>
                        `
                    },
                    {
                        question: "Was passiert nach einer positiven Machbarkeitsstudie?",
                        answer: `
                            <p> Wir erstellen ein konkretes Standortkonzept, legen gemeinsam mit der Gemeinde nächste Schritte fest und übernehmen auf Wunsch die Koordination mit Eigentümern, Behörden und regionalen Erzeugern.</p>
                            <p>Ziel ist eine Eröffnung innerhalb von 6 Monaten.</p>
                        `
                    },
                    {
                        question: "Welche Vorteile bringt eine Yobsti-Filiale für unsere Gemeinde?",
                        answer: `
                            <p> Yobsti bringt das zurück, was viele kleine Orte vermissen: eine zuverlässige Nahversorgung – modern gedacht, lokal verankert.Eine Filiale bedeutet:</p>
                            <ul class="list-disc list-inside mt-2 space-y-1">
                            <li>mehr Lebensqualität, besonders für ältere Menschen und Familien ohne Auto</li>
                            <li>einen echten Treffpunkt, der den Alltag leichter macht</li>
                            <li>ein sichtbares Zeichen für Fortschritt, Zusammenhalt und Zukunftsfähigkeit</li>
                            <li>neue Chancen für regionale Anbieter – direkt vor Ort</li>
                            <li>weniger Verkehr, kürzere Wege und damit weniger CO₂</li>
                            </ul>
                            <p class="mt-2">Und das Beste: Yobsti funktioniert ganz ohne zusätzliches Personal oder laufende Kosten für die Gemeinde.</p>
                            <p class="mt-2 font-semibold">Kurz gesagt: Yobsti macht das Leben auf dem Land einfacher, moderner – und ein Stück lebenswerter.</p>
                       `
                    },
                    {
                        question: "Welche Auswirkungen hat Yobsti auf die lokale Wirtschaft und Nahversorgung?",
                        answer: `
                            <p> Yobsti versteht sich als Ergänzung – nicht als Ersatz.Unser Ziel ist es, vorhandene Strukturen zu stärken, nicht zu verdrängen.</p>
                            <p>Wir schaffen neue Absatzwege für lokale Händler, Direktvermarkter und Produzenten – auch über die regulären Öffnungszeiten hinaus.</p>
                            <p>Ein Beispiel: Gibt es bereits einen Gemüsehändler im Ort, kann dieser seine Produkte zusätzlich über Yobsti anbieten – ohne eigenes Personal, mit voller Kontrolle über Sortiment und Preis.</p>
                            <p>Wir arbeiten partnerschaftlich, transparent und mit großem Respekt für die lokale Identität. Doppelstrukturen vermeiden wir bewusst – stattdessen fördern wir regionale Synergien und machen bestehende Angebote sichtbarer und zugänglicher.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={home}
                title="Voraussetzungen & Standortwahl"
                faqs={[
                    {
                        question: 'Welche Voraussetzungen muss unsere Gemeinde erfüllen, damit ein Yobsti realisiert werden kann?',
                        answer: `
                           <p> <strong>Yobsti gibt es in zwei Varianten – beide sind vollständig automatisierte Smart Stores:</strong></p>
                            <p>🔹 <strong>Yobsti to Go</strong> (Container, ca. 22 m²)<br/>Die kompakte Lösung für kleine Orte ab 800 Einwohnern.</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Mind. 15 × 5 m befestigte und ebene Fläche</li>
                                <li>Zentrale Lage oder gut sichtbarer Durchgangsbereich</li>
                                <li>Stromanschluss: 5x16 mm² Erdleitung, 25 A</li>
                                <li>Internetanschluss: mind. 100 MBit/s</li>
                                <li>Wasser-/Abwasseranschluss von Vorteil</li>
                                <li>Zuwegung für Transporter & Schwerlastkran</li>
                                <li>Mind. 3 Kundenparkplätze</li>
                            </ul>
                            <p class="mt-4">🔸 <strong>Yobsti Markt</strong> (Ladenfläche, 50–300 m²)<br/>Die größere Variante für Gemeinden ab 1.500 Einwohnern.</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Mind. 50–300 m² Verkaufsfläche</li>
                                <li>Raumhöhe: mind. 2,50 m</li>
                                <li>Stromanschluss, stabile Internetverbindung</li>
                                <li>Barrierefreier Zugang</li>
                                <li>Kundenparkplätze & Anlieferzone</li>
                                <li>Nutzungsgenehmigung als Einzelhandel</li>
                                <li>Erfüllung brandschutztechnischer Vorgaben</li>
                            </ul>
                        `
                    },
                    {
                        question: 'Wie wählt Yobsti den Standort aus?',
                        answer: `
                            <p> Wir arbeiten mit einem detaillierten Kriterienkatalog.Dabei zählen u.a.:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Sichtbarkeit und zentrale Lage</li>
                                <li>Erreichbarkeit zu Fuß, per Fahrrad & Auto</li>
                                <li>Technische Voraussetzungen (Strom, Internet etc.)</li>
                                <li>Flächenverfügbarkeit & Nutzungsrecht</li>
                                <li>Einwohnerzahl, Versorgungslage & Wettbewerb</li>
                                <li>Bürgerbefragung zur Potenzialabschätzung</li>
                                <li>Wirtschaftlichkeitsprüfung & Mindestumsatz</li>
                            </ul>
                            <p class="mt-2">Diese Kriterien werden im Rahmen der kostenlosen Machbarkeitsstudie geprüft.</p>
                        `
                    },
                    {
                        question: 'Welche baulichen Bedingungen sind zu beachten?',
                        answer: `
                            <p> Die Anforderungen unterscheiden sich je nach Variante.Grundsätzlich gelten:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li><strong>Brandschutz:</strong> 2 Fluchtwege, Brandabstände</li>
                                <li><strong>Raumhöhe:</strong> mind. 2,50 m (ideal 2,80–3,00 m)</li>
                                <li><strong>Barrierefreiheit:</strong> ebenerdig oder Rampe</li>
                                <li><strong>Serviceraum:</strong> mind. 2,5 × 0,75 m</li>
                                <li><strong>Werbeflächen:</strong> baurechtlich zulässig</li>
                                <li><strong>Zugangstür:</strong> mind. 1 m breit, 2,25 m hoch, umrüstbar</li>
                            </ul>
                            <p class="mt-2">Diese Punkte werden individuell geprüft und mit Behörden abgestimmt.</p>
                        `
                    },
                    {
                        question: 'Der nächste Supermarkt ist 5 km entfernt – lohnt sich ein Yobsti trotzdem?',
                        answer: `
                            <p> Ja! Genau dafür ist Yobsti gemacht – für Gemeinden mit Versorgungslücken.</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Bessere Versorgung für Senioren, Familien, Menschen ohne Auto</li>
                                <li>Ort für spontane Einkäufe</li>
                                <li>Stärkung der Dorfgemeinschaft & regionaler Anbieter</li>
                                <li>Klimafreundlich durch kurze Wege</li>
                            </ul>
                            <p class="mt-2">Yobsti ist eine vollwertige Lösung mit allen Produkten des täglichen Bedarfs. Eine Umsetzung erfolgt nur, wenn der Standort durch unsere Analyse tragfähig ist.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={aboutUs}
                title="Zusammenarbeit & Beteiligung"
                faqs={[
                    {
                        question: 'Welche Beteiligung wird von der Gemeinde erwartet?',
                        answer: `
                            <p> Yobsti versteht sich als <strong> Partner der Gemeinde</strong> – nicht als externer Anbieter mit Fertiglösung.Der Erfolg hängt davon ab, wie gut die Kommune den Prozess begleitet.</p>
                            <p class="mt-2">Wichtig ist <strong>nicht</strong> der finanzielle Beitrag, sondern die <strong>lokale Unterstützung</strong> in diesen Bereichen:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Standortfindung & Kontakt zu Eigentümer:innen</li>
                                <li>Politische Rückendeckung durch Gremien</li>
                                <li>Genehmigungsmanagement & Förderprogramme</li>
                                <li>Aktivierung der Bevölkerung (Umfragen, Presse)</li>
                                <li>Einbindung lokaler Netzwerke & Erzeuger</li>
                            </ul>
                            <p class="mt-2">So entsteht breite Akzeptanz – und langfristiger Erfolg.</p>
                        `
                    },
                    {
                        question: 'Wie gestaltet sich die Zusammenarbeit zwischen Yobsti und der Kommune?',
                        answer: `
                            <p> Die Umsetzung erfolgt durch Yobsti oder in Partnerschaft mit erfahrenen Akteuren aus Projektentwicklung und Bau.</p>
                            <p class="mt-2">Ein <strong>klar definierter Ansprechpartner</strong> koordiniert den gesamten Prozess:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Machbarkeitsprüfung</li>
                                <li>Antragsverfahren</li>
                                <li>Standortumsetzung & Eröffnung</li>
                            </ul>
                            <p class="mt-2">Die Gemeinde bleibt eng eingebunden, wird aber <strong>nicht operativ belastet</strong>. Ziel ist eine verlässliche Partnerschaft mit <strong>klaren Rollen</strong> und <strong>verbindlicher Kommunikation</strong>.</p>
                        `
                    },
                    {
                        question: 'Wie lange dauert es von der ersten Kontaktaufnahme bis zur Eröffnung?',
                        answer: `
                            <p> Die Umsetzung ist je nach Standorttyp und Genehmigung in <strong>4–6 Monaten</strong> realistisch.</p>
                            <p class="mt-2">Typischer Ablauf:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Interessenformular</li>
                                <li>Erstgespräch & Zielabgleich</li>
                                <li>Machbarkeitsstudie inkl. Ortsbegehung</li>
                                <li>Entscheidung & Partnerzuweisung</li>
                                <li>Umsetzung & Eröffnung</li>
                            </ul>
                            <p class="mt-2">Die Infrastruktur ist so konzipiert, dass Standorte <strong>digital vorbereitet</strong> und <strong>schnell aktiviert</strong> werden können – egal ob Container oder Marktfiliale.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={cart}
                title="Sortiment & Regionalität"
                faqs={[
                    {
                        question: 'Wie sieht das Sortiment von Yobsti aus?',
                        answer: `
                           <p> Das Sortiment richtet sich nach der Größe des jeweiligen Standorts – vom kompakten <strong> Yobsti to Go</strong> bis zum <strong> Yobsti Markt</strong> mit bis zu 300 m².</p>
                            <p class="mt-2">Die Anzahl der Artikel variiert von ca. 400 Produkten bis über 1.200. Alle Standorte greifen auf eine kuratierte Produktdatenbank mit über 25.000 Artikeln zu.</p>
                            <p class="mt-2">Unser Sortiment umfasst:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Frisches Obst und Gemüse</li>
                                <li>Molkereiprodukte, Fleisch- und Wurstwaren</li>
                                <li>Backwaren, Tiefkühlkost</li>
                                <li>Drogerieartikel, Grundnahrungsmittel, Getränke</li>
                            </ul>
                            <p class="mt-2">Ergänzt durch:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>Markenprodukte & Handelsmarken</li>
                                <li>Produkte junger Startups</li>
                                <li>Regionale Erzeugnisse</li>
                            </ul>
                            <p class="mt-2">Durch digitale Warenwirtschaft (Odoo) und Echtzeit-Analyse wird das Sortiment laufend optimiert – basierend auf Standort, Nachfrage und Saison.</p>
                       `
                    },
                    {
                        question: 'Wie werden regionale Produkte in das Sortiment integriert?',
                        answer: `
                            <p> Regionale Produkte sind <strong> fester Bestandteil</strong> unseres Konzepts.Yobsti ist ein Marktplatz für echte Nähe – nicht ein anonymer Handelskanal.</p>
                            <p class="mt-2">Produkte lokaler Erzeuger werden:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li>bevorzugt aufgenommen</li>
                                <li>mit Herkunft und QR-Code präsentiert</li>
                                <li>in speziell gekennzeichneten Bereichen gezeigt</li>
                            </ul>
                            <p class="mt-2">Integration erfolgt über unser ERP-System (Odoo) mit Nachverfolgbarkeit, automatischer Abrechnung und flexibler Preisgestaltung.</p>
                            <p class="mt-2">Erzeuger können selbst nachfüllen oder logistisch eingebunden werden.</p>
                       `
                    },
                    {
                        question: 'Wie können lokale Erzeuger Teil des Yobsti-Konzepts werden?',
                        answer: `
                            <p> Lokale Produzent:innen sind das <strong> Herzstück</strong> von Yobsti.Sie verkaufen direkt im Markt – ganz ohne Zwischenhandel.</p>
                            <p class="mt-2">Der Einstieg erfolgt über unser Interessenformular. Danach begleitet unser Team den gesamten Prozess:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li><strong>Kontakt & Produktvorschlag</strong>: Vorstellung, Produktauswahl, Vertriebsmodell</li>
                                <li><strong>Qualitätsprüfung</strong>: Geschmack, Verpackung, Etikettierung</li>
                                <li><strong>Digitale Integration</strong>: Eintrag ins ERP-System, Lieferabsprachen, Vermarktung</li>
                            </ul>
                            <p class="mt-2">Mögliche Vertriebsmodelle:</p>
                            <ul class="list-disc list-inside mt-2">
                                <li><strong>Direktvermarktung</strong>: volle Kontrolle, hohe Marge</li>
                                <li><strong>Kommission</strong>: einfach, risikoarm</li>
                                <li><strong>Direkteinkauf durch Yobsti</strong>: planbar, automatisiert</li>
                            </ul>
                            <p class="mt-2">Yobsti verbindet Technologie mit echter Regionalität – sichtbar, selbstbestimmt und skalierbar.</p>
                       `
                    }
                ]}
            />

            <FaqAccordion
                icon={dollarGreen}
                title="Betrieb & Wirtschaftlichkeit"
                faqs={[
                    {
                        question: 'Wie stellt Yobsti sicher, dass sich ein Standort wirtschaftlich trägt?',
                        answer: `
                           <p> Die Wirtschaftlichkeit eines Yobsti - Markts hängt von mehreren Faktoren ab – etwa der Lage, dem Einzugsgebiet und der örtlichen Mobilität.</p>
                            <p class="mt-2">Wir nutzen ein strukturiertes Analysemodell, bestehend aus:</p>
                            <ul class="list-disc list-inside mt-2">
                            <li>Machbarkeitsstudie vor Projektstart</li>
                            <li>Standort-Scoring (Sichtbarkeit, Zugänglichkeit, Einwohnerzahl)</li>
                            <li>Bedarfsanalyse über Bürgerumfragen</li>
                            <li>Sortimentsanpassung basierend auf Nachfrageprognosen</li>
                            </ul>
                            <p class="mt-2">Nur bei ausreichendem Potenzial empfehlen wir die Umsetzung – und tragen selbst das Risiko.</p>
                            <p class="mt-2">Dank digitaler Infrastruktur können wir jeden Standort laufend überwachen, Logistik optimieren und Sortimente steuern – für dauerhafte Tragfähigkeit statt schneller Expansion.</p>
                           `
                    },
                    {
                        question: 'Welche Risiken sind mit einem Yobsti-Standort verbunden – und wie geht ihr damit um?',
                        answer: `
                            <p> Wie bei jedem Handelsstandort gibt es Risiken – aber unser Konzept minimiert sie systematisch.</p>
                            <p class="mt-2">Typische Risiken:</p>
                            <ul class="list-disc list-inside mt-2">
                            <li>Unterschätzter Bedarf</li>
                            <li>Technische Ausfälle</li>
                            <li>Geringe Akzeptanz im Ort</li>
                            </ul>
                            <p class="mt-2">Unsere Gegenmaßnahmen:</p>
                            <ul class="list-disc list-inside mt-2">
                            <li><strong>Gründliche Vorprüfung</strong>: Nur Standorte mit belegbarem Potenzial</li>
                            <li><strong>Technisch robuste Systeme</strong>: Cloudbasiert, überwacht, fehlertolerant</li>
                            <li><strong>Laufendes Monitoring</strong>: Echtzeitdaten zu Umsatz, Technik, Kundenfrequenz</li>
                            <li><strong>Regionale Verankerung</strong>: Kommunikation, Infoveranstaltungen, lokales Marketing</li>
                            </ul>
                            <p class="mt-2">Unser Ziel ist kein Copy-Paste-Wachstum, sondern funktionierende Läden – mit realistischen Erwartungen und lokaler Identifikation.</p>
                            `
                    },
                    {
                        question: 'Welche Expansionspläne verfolgt Yobsti in den kommenden Jahren?',
                        answer: `
                            <p> Yobsti wächst bewusst und schrittweise – aktuell vor allem in Rheinland - Pfalz und Baden - Württemberg.</p>
                            <p class="mt-2">Unsere Schwerpunkte:</p>
                            <ul class="list-disc list-inside mt-2">
                            <li>Systemstabilisierung und Weiterentwicklung</li>
                            <li>Technologie- und Betriebslabore an den ersten Standorten</li>
                            <li>Standardisierung von Planung, Aufbau und Betrieb</li>
                            </ul>
                            <p class="mt-2">Zukünftige Schritte:</p>
                            <ul class="list-disc list-inside mt-2">
                            <li>Ausbau im regionalen Umfeld</li>
                            <li>Übertragung auf ähnliche Gemeinden</li>
                            <li>Qualität vor Geschwindigkeit bei bundesweiten Anfragen</li>
                            </ul>
                            <p class="mt-2">Unser Ziel: ein tragfähiges Modell der Nahversorgung – skalierbar, aber niemals beliebig.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={transparency}
                title="Marketing & Sichtbarkeit"
                faqs={[
                    {
                        question: 'Wie unterstützt Yobsti die Bekanntmachung vor Ort?',
                        answer: `
                            <p> Ein Yobsti soll nicht einfach „stehen“ – er soll <strong> angekommen</strong> sein.Deshalb begleiten wir jede Eröffnung mit einem umfassenden Maßnahmenpaket für lokale und digitale Sichtbarkeit.</p>

                            <h4 class="font-semibold mt-4">Vor-Ort-Kommunikation</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Eröffnungsevent mit lokalem Charakter (z. B. mit Vereinen und Gemeindevertreter:innen)</li>
                            <li>Flyer, Plakate und Broschüren – individualisierbar</li>
                            <li>Pressearbeit mit regionalen Medien</li>
                            <li>Infomaterialien für Gemeinde, Schulen, Arztpraxen etc.</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Digitale Sichtbarkeit</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Beiträge auf unseren Social-Media-Kanälen</li>
                            <li>Einbindung auf Gemeindewebsites oder Bürger-Apps</li>
                            <li>Standortbasierte Online-Kampagnen (z. B. Google, Facebook)</li>
                            <li>Integration in die zentrale Yobsti-Kundenplattform</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Bürgeraktivierung & Identifikation</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Unterstützung bei lokalen Infoveranstaltungen</li>
                            <li>Bereitstellung eines FAQ-Pakets für Multiplikator:innen</li>
                            <li>Vermittlung lokaler Paten oder Ansprechpartner:innen</li>
                            </ul>

                            <p class="mt-2">Alle Maßnahmen sind modular und flexibel – die Gemeinde entscheidet, was sie nutzt. Ziel ist nicht nur Bekanntheit, sondern das Gefühl: <strong>„Das ist unser Yobsti.“</strong></p>
                        `
                    },
                    {
                        question: 'Gibt es Beispiele oder Referenzen für bestehende Yobsti-Standorte?',
                        answer: `
                            <p> Ja – erste Standorte sind bereits erfolgreich in Betrieb und zeigen, wie Yobsti<strong> in der Praxis funktioniert</strong>.</p>
                            <p class="mt-2">Wir veröffentlichen regelmäßig Einblicke, Bilder und Erfahrungsberichte auf unserer Website und in unseren Kanälen. So erhalten interessierte Gemeinden authentische Einblicke in:</p>
                            <ul class="list-disc list-inside mt-2">
                            <li>Umsetzung und Aufbau</li>
                            <li>Alltagsnutzung und Akzeptanz</li>
                            <li>Einbindung regionaler Produzenten</li>
                            </ul>
                            <p class="mt-2">Auf Wunsch vermitteln wir Kontakt zu ausgewählten Pilotprojekten – abhängig von Region und Projektstand.</p>
                            <p class="mt-2"><strong>Unser Anspruch:</strong> Transparenz durch echte Einblicke – nicht durch Werbeversprechen.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={plantHand}
                title="Nachhaltigkeit & soziale Aspekte"
                faqs={[
                    {
                        question: 'Wie steht Yobsti zu Nachhaltigkeit und Umweltschutz?',
                        answer: `
                            <p> Nachhaltigkeit ist bei Yobsti kein Zusatz, sondern ein <strong> Kernprinzip</strong> – von der Standortwahl bis zum Warenregal.</p>

                            <h4 class="font-semibold mt-4">Regionale Lieferketten</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Einbindung regionaler Erzeuger reduziert Transportwege</li>
                            <li>Frischeprodukte aus der Umgebung statt Massenlogistik</li>
                            <li>Förderung nachhaltiger Direktvermarktung</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Technisch energieeffizient</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Stromsparende Kühltechnik, LED, Wärmerückgewinnung</li>
                            <li>Intelligente Klimasteuerung nach Bedarf</li>
                            <li>Niedrige Grundlast bei Yobsti to Go (Containerlösung)</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Vermeidung von Lebensmittelverschwendung</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Digitale Überwachung von Haltbarkeit und Bestand</li>
                            <li>Dynamische Preise bei drohendem Verfallsdatum</li>
                            <li>Resteverwertung mit Partnerdiensten</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Weniger Individualverkehr</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Weniger Autofahrten durch Nahversorgung im Ort</li>
                            <li>Besonders hilfreich für ältere Menschen und Haushalte ohne Auto</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Nachhaltigkeit auch im Denken</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Bewusster Konsum durch kuratiertes Sortiment</li>
                            <li>Stärkung nachhaltiger Anbieter</li>
                            <li>Keine versiegelten Flächen – modulare Konzepte</li>
                            </ul>

                            <p class="mt-2"><strong>Yobsti denkt Nachhaltigkeit strukturell, digital und sozial.</strong></p>
                        `
                    },
                    {
                        question: 'Kann der Yobsti als sozialer Treffpunkt genutzt werden?',
                        answer: `
                            <p> Yobsti ist in erster Linie ein <strong> digitaler Nahversorger</strong> – kein Café oder Begegnungszentrum.</p>
                            <p class="mt-2">Aber: Wir schaffen bewusst <strong>Raum für soziale Komponenten</strong> – wenn Gemeinden dies wünschen.</p>

                            <ul class="list-disc list-inside mt-2">
                            <li>Platz für Sitzgelegenheiten, Infoflächen oder Mini-Tauschstationen im Außenbereich</li>
                            <li>Unterstützung von lokalen Initiativen mit Technik, Know-how und Materialien</li>
                            </ul>

                            <p class="mt-2">Was wir <strong>nicht anbieten</strong>: Betrieb eigener Gastronomie oder Caféflächen – das ist in unserem Modell ohne Personal nicht tragfähig.</p>
                            <p class="mt-2">Unser Ziel ist es, Begegnung zu <strong>ermöglichen</strong>, aber nicht selbst Gastgeber zu sein.</p>
                        `
                    },
                    {
                        question: 'Können auch ältere Menschen mit Yobsti zurechtkommen?',
                        answer: `
                            <p> <strong>Ja</strong> – das ist uns besonders wichtig.Yobsti ist barrierefrei und leicht verständlich für alle Generationen.</p>

                            <h4 class="font-semibold mt-4">Einfache Bedienung</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Zugang per Chipkarte – kein Smartphone nötig</li>
                            <li>Selbsterklärende Kasse mit Text und Bildern</li>
                            <li>Groß beschriftete Regale und klare Beschilderung</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Zusätzliche Unterstützung</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Einführungsveranstaltungen oder Info-Nachmittage</li>
                            <li>Papierhafte Begleithefte und Schritt-für-Schritt-Anleitungen</li>
                            <li>Lokale Ansprechpartner:innen oder Patenmodelle</li>
                            </ul>

                            <p class="mt-2">Das Feedback zeigt: Nach kurzer Eingewöhnung wird Yobsti zur selbstverständlichen Routine – auch für ältere Nutzer:innen.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={time}
                title="Betriebszeiten & Sicherheit"
                faqs={[
                    {
                        question: 'Wie lange ist der Yobsti geöffnet?',
                        answer: `
                            <p>Jeder Yobsti ist als vollautomatisierter Smart Store ohne Personal konzipiert. Die Öffnungszeiten passen wir <strong>situationsabhängig</strong> an – in enger Abstimmung mit der Gemeinde.</p>

                            <h4 class="font-semibold mt-4">Faktoren bei der Festlegung:</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>örtliche Lage (z. B. Wohnbebauung vs. Alleinlage)</li>
                            <li>sicherheitsrelevante Aspekte (Beleuchtung, Überwachung, Zugang)</li>
                            <li>Rückmeldungen der Bevölkerung</li>
                            <li>kommunale Vorgaben (Satzungen, B-Pläne)</li>
                            </ul>

                            <p class="mt-2">In vielen Gemeinden hat sich ein Betrieb von <strong>6 bis 23 Uhr</strong> bewährt.</p>
                        `
                    },
                    {
                        question: 'Was tut Yobsti gegen Diebstahl?',
                        answer: `
                            <p> <strong>Sicherheit</strong> ist fester Bestandteil des Yobsti - Konzepts – auch ohne Personal vor Ort.</p>

                            <h4 class="font-semibold mt-4">Unsere Sicherheitsmaßnahmen:</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Zugang nur mit persönlicher Chipkarte</li>
                            <li>lückenlose, datenschutzkonforme Videoüberwachung im Innenbereich</li>
                            <li>Self-Checkout mit digitaler Produkterfassung</li>
                            <li>automatisiertes Monitoring bei Auffälligkeiten oder Inventurdifferenzen</li>
                            </ul>

                            <p class="mt-2">Geplant ist eine <strong>zeitlich eingeschränkte Zugangskontrolle</strong>: In Nachtstunden nur mit personalisierter Karte.</p>
                            <p>Ein App-Zugang ist in Vorbereitung, aber aktuell noch nicht im Einsatz.</p>

                            <p class="mt-2">Im Fall eines Diebstahls wird der Vorgang <strong>konsequent verfolgt</strong> – inklusive Zugangssperre und ggf. Strafanzeige.</p>

                            <p class="mt-2"><strong>Vertrauen</strong> ist die Basis – ergänzt durch professionellen Schutz für alle Beteiligten.</p>
                        `
                    },
                    {
                        question: 'Kommt es durch Yobsti zu Lärmbelästigung?',
                        answer: `
                            <p> <strong>Nein</strong> – der Betrieb ist <strong> äußerst geräuscharm</strong> und auch für sensible Ortslagen geeignet.</p>

                            <h4 class="font-semibold mt-4">Warum?</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Kein Personal, keine Lautsprecherdurchsagen, keine Kassenansagen</li>
                            <li>Lieferung tagsüber mit Kleintransportern – keine Nachtanlieferung</li>
                            <li>Moderne, leise Technik: Kühlung, Türen, Kassensysteme</li>
                            <li>Keine Lüftungsanlagen, Rampen oder Rollcontainer</li>
                            </ul>

                            <h4 class="font-semibold mt-4">Zusätzlich:</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>gezielte Eingangsausrichtung</li>
                            <li>blendfreie Beleuchtung</li>
                            <li>dezente Gestaltung der Außenbereiche</li>
                            </ul>

                            <p class="mt-2">Yobsti fügt sich <strong>unauffällig</strong> ins Ortsbild ein – leise, effizient und rücksichtsvoll.</p>
                        `
                    }

                ]}
            />

            <FaqAccordion
                icon={cog}
                title="Technischer Betrieb & Wartung"
                faqs={[
                    {
                        question: 'Wer betreibt und wartet den Yobsti?',
                        answer: `
                            <p> Der Betrieb eines Yobsti - Markts liegt vollständig bei der <strong> Yobst GmbH</strong> oder einem von uns zertifizierten Partner.</p>

                            <p class="mt-2">Die Gemeinde trägt <strong>keine Verantwortung</strong> für Technik, Logistik oder Kundenservice.</p>

                            <h4 class="font-semibold mt-4">Wartung & Support:</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Regelmäßige Fernwartung durch unser zentrales IT- und Betriebsteam</li>
                            <li>Reparaturen & Notfälle über regionale Partnernetzwerke</li>
                            <li>Technische Hotline für Meldungen und Rückfragen – <strong>7 Tage die Woche</strong></li>
                            </ul>

                            <p class="mt-2">So stellen wir einen verlässlichen Betrieb sicher – <strong>ohne Aufwand für die Kommune</strong>.</p>
                        `
                    },
                    {
                        question: 'Was passiert bei einem technischen Defekt oder Stromausfall?',
                        answer: `
                            <p> Alle Yobsti - Standorte sind mit einem <strong> intelligenten Monitoring - System</strong> ausgestattet.</p>

                            <p class="mt-2">Störungen werden automatisch erkannt und <strong>an unser zentrales Betriebsteam gemeldet</strong>.</p>

                            <h4 class="font-semibold mt-4">Im Falle eines Stromausfalls:</h4>
                            <ul class="list-disc list-inside mt-2">
                            <li>Sicherheitsrelevante Systeme sind über <strong>USV (unterbrechungsfreie Stromversorgung)</strong> abgesichert</li>
                            <li>Die Tür lässt sich <strong>immer manuell von innen</strong> öffnen – keine Gefahr für Kund:innen</li>
                            <li>Unser Betriebsteam wird <strong>sofort informiert</strong> und leitet Maßnahmen ein</li>
                            </ul>

                            <p class="mt-2">Der Betrieb ist auf <strong>maximale Ausfallsicherheit</strong> ausgelegt – auch in ländlichen Regionen.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={briefcase}
                title="Rechtliches & Trägerschaft"
                faqs={[
                    {
                        question: 'Wer ist Betreiber des Markts – die Gemeinde oder Yobsti?',
                        answer: `
                            <p> Die Verantwortung für <strong> Aufbau, Betrieb und Instandhaltung</strong> liegt bei <strong> Yobsti</strong> oder einem offiziellen Partner.</p>

                            <p class="mt-2">Die Gemeinde ist <strong>weder wirtschaftlich noch rechtlich haftbar</strong> – es sei denn, es wird explizit eine Beteiligungsform vereinbart (z. B. Flächenbereitstellung oder Projektförderung).</p>

                            <p class="mt-2">Damit ist Yobsti ein <strong>Angebot für Ihre Bürger:innen</strong> – ohne operative Belastung für Verwaltung oder Gemeinderat.</p>
                        `
                    },
                    {
                        question: 'Gibt es Förderprogramme, die für einen Yobsti in Frage kommen?',
                        answer: `
                            <p> Je nach Region und Standort kann ein Yobsti - Markt <strong> förderfähig</strong> sein – etwa im Rahmen von:</p>

                            <ul class="list-disc list-inside mt-2">
                            <li><strong>LEADER-Programmen</strong></li>
                            <li><strong>Digitalisierungs- und Smart Village-Förderungen</strong></li>
                            <li><strong>Nahversorgungs- oder Strukturförderinitiativen</strong> auf Landes- oder Bundesebene</li>
                            </ul>

                            <p class="mt-2">Wir unterstützen Sie gerne bei der <strong>Identifikation geeigneter Programme</strong> sowie der <strong>Antragstellung</strong>.</p>
                        `
                    }
                ]}
            />

            <FaqAccordion
                icon={alignButtom}
                title="Erfolgsmessung & Weiterentwicklung"
                faqs={[
                    {
                        question: 'Wie wird die Nutzung des Yobsti erfasst und ausgewertet?',
                        answer: `
                            <p> Über unser zentrales Softwaresystem erhalten wir genaue Einblicke in:</p>

                            <ul class="list-disc list-inside mt-2">
                            <li>Kundenfrequenzen</li>
                            <li>Umsatzverläufe</li>
                            <li>Produkthäufigkeit und Sortimentsentwicklung</li>
                            </ul>

                            <p class="mt-2">Diese Daten werden <strong>anonymisiert</strong> verarbeitet und können – je nach Vereinbarung – auch mit der Gemeinde geteilt werden, z. B. im Rahmen von Projektberichten, Gemeinderatssitzungen oder zur Fördermittelabrechnung.</p>

                            <p class="mt-2">So bleibt die Gemeinde <strong>informiert und involviert</strong>, ohne aktiv eingreifen zu müssen.</p>
                        `
                    },
                    {
                        question: 'Wie können wir als Gemeinde den Standort langfristig unterstützen?',
                        answer: `
                            <p> Yobsti funktioniert am besten mit <strong> kommunalem Rückhalt</strong>.Gemeinden können unterstützen durch:</p>

                            <ul class="list-disc list-inside mt-2">
                            <li>Sichtbarkeit auf Gemeindewebsites, Social Media oder Infokanälen</li>
                            <li>Beteiligung an Eröffnung oder Infoveranstaltungen</li>
                            <li>Kontaktvermittlung zu lokalen Erzeugern oder Vereinen</li>
                            <li>Patenschaftsmodelle, z. B. mit Senior:innen, Jugendlichen oder Ehrenamtlichen</li>
                            </ul>

                            <p class="mt-2">Ziel ist nicht Kontrolle – sondern <strong>gelebte Mitgestaltung</strong>.</p>
                        `
                    }

                ]}
            />

            <FaqAccordion
                icon={location}
                title="Flächen & Eigentumsfrage"
                faqs={[
                    {
                        question: 'Kann der Yobsti auch auf kommunalem Grund errichtet werden?',
                        answer: `
                            <p> Ja – viele Gemeinden stellen geeignete Flächen zur Verfügung, z.B.auf <strong> öffentlichen Parkplätzen</strong>, am <strong> Rathaus</strong> oder bei <strong> Bushaltestellen</strong>.</p>

                            <p class="mt-2">Die Nutzung erfolgt über:</p>
                            <ul class="list-disc list-inside mt-1">
                            <li>Mietverträge</li>
                            <li>Erbbaurechte</li>
                            <li>formlose Gestattungen – je nach Modell und Rechtslage</li>
                            </ul>

                            <p class="mt-2">Wir prüfen jede Fläche <strong>gemeinsam mit Ihnen</strong> – rechtlich und wirtschaftlich.</p>
                        `
                    },
                    {
                        question: 'Wie flexibel ist der Rückbau, wenn sich das Projekt nicht bewährt?',
                        answer: `
                            <p> Gerade unsere <strong> Containerlösung(Yobsti to Go)</strong> bietet maximale Flexibilität:</p>

                            <p class="mt-2">Der Rückbau ist innerhalb <strong>weniger Tage</strong> möglich, die Fläche kann danach sofort anderweitig genutzt werden.</p>

                            <p class="mt-2">Auch bei <strong>Laden-Märkten (feste Gebäude)</strong> legen wir Wert auf <strong>modulare Umbauten</strong> und klare <strong>Rückbaukonzepte</strong>. Sollte der Standort nicht tragfähig sein, entstehen <strong>keine dauerhaften Verpflichtungen</strong> für die Gemeinde.</p>
                        `
                    }

                ]}
            />
        </div >
    );
}
